module.exports = __webpack_public_path__ + "img/shape-octagon.6541e07e.svg";